/* import __COLOCATED_TEMPLATE__ from './qa-assignee.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Inbox2AssigneeSearch from 'embercom/services/inbox2-assignee-search';
import AdminSummary from 'embercom/objects/inbox/admin-summary';
import type TeammateBrowserSettings from 'embercom/services/teammate-browser-settings';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    adminId?: number;
  };
}

export default class QaAssignee extends Component<Signature> {
  @service declare inbox2AssigneeSearch: Inbox2AssigneeSearch;
  @service declare teammateBrowserSettings: TeammateBrowserSettings;
  @service declare intl: IntlService;

  get admin(): AdminSummary | undefined {
    let id = this.args.adminId;
    if (id === undefined) {
      return undefined;
    }
    // Check if the assignee is the operator bot (auto-reviewed)
    try {
      if (id === this.teammateBrowserSettings.settings.operatorBotId) {
        return new AdminSummary(
          id,
          this.intl.t('inbox.search.filters.qa-assignee.auto-reviewed'),
          null,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
        );
      }
    } catch {
      // Settings not yet loaded — fall through to normal admin lookup
    }
    return this.inbox2AssigneeSearch.findAdminById(id);
  }

  get isAutoReviewed(): boolean {
    return this.admin?.isOperator === true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::QaAssignee': typeof QaAssignee;
    'inbox2/conversations-table/table-cells/qa-assignee': typeof QaAssignee;
  }
}
